import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rptloanoutstandingpopup',
  templateUrl: './rptloanoutstandingpopup.component.html',
  styleUrls: ['./rptloanoutstandingpopup.component.css']
})
export class RptloanoutstandingpopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
